/* eslint-disable camelcase */
import React from "react";
import { useTranslation } from "ceco-polyglot";
import { Link } from "found";
import DifficultyRate from "../Recipe/DifficultyRate";
import StatusButton from "../StatusButton";
import PortionIconNumber from "../PortionIconNumber";
import { MoreVertical, Edit, Delete } from "ceicons";
import { RecipeModal } from "../modals/RecipeModal";
import { RecipeDeleteModal } from "../modals/RecipeDeleteModal";
import { Card, Image } from "semantic-ui-react";
import DropDownButton from "../../components/DropDownButton";
import TrendButton from "../TrendButton";

import "./recipesCards.scss";

export default function RecipesCards({
  allCategories,
  recipesParsed,
  refetchData,
  filters,
  allLabel,
  pageInfo: { hasNextPage },
}) {
  const t = useTranslation();

  return (
    <Card.Group className="cards-wrapper">
      {recipesParsed.map((card) => {
        return (
          <div className="recipe-card-container" key={card.id}>
            <TrendButton
              recipeId={card.id}
              trend={card.isTrend}
              recipeName={card.name}
              reload={filters.isTrend}
              refetchData={refetchData}
            />

            <DropDownButton icon={<MoreVertical />}>
              <RecipeModal
                edit
                recipe={{ ...card, category: card.category.id }}
                allCategories={allCategories}
                allLabel={allLabel}
                trigger={
                  <div>
                    <Edit />
                    <p>{t("popup.edit")}</p>
                  </div>
                }
                refetchData={refetchData}
              />
              <RecipeDeleteModal
                recipeId={card.id}
                recipeName={card.name}
                refetchData={refetchData}
                trigger={
                  <div className="delete-modal">
                    <Delete />
                    <p>{t("popup.remove")}</p>
                  </div>
                }
              />
            </DropDownButton>

            <Card className="recipeCard">
              <Link key={card.id} to={`/recipe/${card.id}`} />
              <Image
                src={card?.mediaFiles?.edges[0]?.node.mediaUrl}
                wrapped
                ui={false}
              />

              <Card.Content>
                <Card.Header>
                  <div>
                    {card.name}
                    <PortionIconNumber portion={card.serves} />
                  </div>

                  <DifficultyRate
                    difficulty={card.difficulty}
                    number={card.difficulty}
                  />
                </Card.Header>

                <Card.Description>
                  <div>
                    {card.category.name}
                    <StatusButton idRecipe={card.id} status={card.published} />
                  </div>
                </Card.Description>
              </Card.Content>
            </Card>
          </div>
        );
      })}
    </Card.Group>
  );
}
